module.exports = __webpack_public_path__ + "images/move_cert_input.svg";